import { jsx as _jsx } from "react/jsx-runtime";
import { Alert } from '@mui/material';
import { theme } from '../themes';
export const AlertInfo = ({ children }) => {
    const primaryMainColor = theme.palette.primary.main;
    return (_jsx(Alert, { sx: {
            backgroundColor: '#EAEBEC',
            color: primaryMainColor,
        }, severity: 'info', children: children }));
};
